import { type MCPServerInfo } from '../../types';

const GitlabServer: MCPServerInfo = {
  serverId: 'GITLAB',
  name: 'GitLab (Legacy)',
  slug: 'gitlab',
  description: 'GitLab (Legacy) MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl:
      'https://github.com/modelcontextprotocol/servers/tree/main/src/gitlab',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['gitlabPersonalAccessToken'],
    properties: {
      gitlabPersonalAccessToken: {
        type: 'string',
        description: 'Your GitLab personal access token.',
        sensitive: true
      },
      gitlabApiUrl: {
        type: 'string',
        description:
          'Base URL for GitLab API, optional for self-hosted instances.',
        sensitive: false,
        default: 'https://gitlab.com/api/v4'
      }
    }
  },
  deprecated: true
};

export default GitlabServer;
